import { AccountSettingsCard } from "../../../components/ops/AccountSettingsCard";
import { PageHeader } from "../../../components/ops/PageHeader";

export function DashboardSettingsPage() {
  return (
    <div>
      <PageHeader title="Settings" subtitle="Manage your account profile" />
      <AccountSettingsCard />
    </div>
  );
}
